const toneData = ['conversational', 'enthusiastic', 'humorous', 'professional']

export default toneData
